// scheduling/utils/staffStats.js
// Personal-schedule stat helpers, shared by MyScheduleView + BacklogView so the
// staff stat bar is identical on both. Ported from StaffDashboard's inline logic.

import { computeStaffWeeklyUtil } from './capacity';

export function getMonday(d) {
  const dt = new Date(d);
  const day = dt.getDay(); // 0=Sun
  dt.setDate(dt.getDate() + (day === 0 ? -6 : 1 - day));
  dt.setHours(0, 0, 0, 0);
  return dt;
}
export function toISO(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
export function addDays(d, n) { const r = new Date(d); r.setDate(r.getDate() + n); return r; }
export function fmtShort(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
export const DOW = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

export function utilColor(pct) {
  if (pct >= 90) return '#EF4444';
  if (pct >= 75) return '#F59E0B';
  return '#10B981';
}

/**
 * Stat-bar numbers for the signed-in staffer: hours this/next week, 4-week total,
 * avg utilization. `schedule` is firm-wide (filtered to meStaffId here); getDayCap +
 * dayHoursByStaff come from the shared data layer.
 */
export function computeStaffStats({ meStaffId, schedule, getDayCap, dayHoursByStaff }) {
  const windowStart = getMonday(new Date());
  const mySchedule = (schedule || []).filter(e => e.StaffId === meStaffId);
  const weekHours = [0, 0, 0, 0];
  for (const e of mySchedule) {
    const d = new Date(e.EntryDate); d.setHours(0, 0, 0, 0);
    const wi = Math.floor((d - windowStart) / (7 * 86400000));
    if (wi < 0 || wi >= 4) continue;
    weekHours[wi] += e.Hours || 0;
  }
  const weekMondays = [];
  for (let i = 0; i < 4; i++) weekMondays.push(toISO(addDays(windowStart, i * 7)));
  let utilSum = 0, utilCount = 0;
  try {
    const rows = computeStaffWeeklyUtil({ staffIds: [meStaffId], weekMondays, getDayCap, dayHoursByStaff });
    for (const w of (rows[0]?.weeks || [])) {
      if (w.pct != null) { utilSum += w.pct; utilCount++; }
    }
  } catch { /* no-op — util falls back to 0 */ }
  return {
    thisWeek: Math.round(weekHours[0] * 100) / 100,
    nextWeek: Math.round(weekHours[1] * 100) / 100,
    total4: Math.round((weekHours[0] + weekHours[1] + weekHours[2] + weekHours[3]) * 100) / 100,
    avgUtil: utilCount > 0 ? Math.round(utilSum / utilCount) : 0,
  };
}
